import { cn } from '@/utils/cn';
import styles from './StepDots.module.scss';
import type { StepDotsProps } from './StepDots.types';

export function StepDots({
  total,
  current,
  onSelect,
  ariaLabel,
  className,
}: StepDotsProps) {
  if (total < 1) return null;
  const interactive = typeof onSelect === 'function';

  return (
    <ol
      className={cn(styles.stepDots, className)}
      aria-label={ariaLabel}
    >
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index === current;
        const commonProps = {
          className: cn(
            styles.stepDots__dot,
            isActive && styles['stepDots__dot--active']
          ),
          'aria-current': isActive ? ('step' as const) : undefined,
        };

        return (
          <li key={index} className={styles.stepDots__item}>
            {interactive ? (
              <button
                type="button"
                onClick={() => onSelect?.(index)}
                aria-label={`Step ${index + 1} of ${total}`}
                {...commonProps}
              />
            ) : (
              <span aria-hidden={!isActive} {...commonProps} />
            )}
          </li>
        );
      })}
    </ol>
  );
}

StepDots.displayName = 'StepDots';
